import article from '@/store/papelera/article'
import sale from '@/store/papelera/sale'
export default {
	namespaced: true,
    modules: {
        article,
    	sale,
    },
}
